import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import api from 'src/api'
import blueSystemsLogo from 'src/img/Logo_BS_Corporate_Quadri.svg'
import SETTINGS from 'src/settings'

interface IAgencyLogo {
  brandName?: string
  isLoaded: boolean
  logo?: string
}

export function useAgencyLogo(): IAgencyLogo {
  const isEnabled = SETTINGS.app.enable_agency_logo
  const [agencyLogo, setAgencyLogo] = useState<IAgencyLogo>({ isLoaded: !isEnabled })

  useEffect(() => {
    if (!isEnabled) {
      return
    }
    api.agencySettings
      .agencyLogoRead()
      .then((response) =>
        setAgencyLogo({ brandName: response.brand_name, isLoaded: true, logo: response.logo ?? undefined })
      )
      .catch((error) => {
        console.error(error)
        setAgencyLogo({ isLoaded: true })
      })
  }, [isEnabled])

  return agencyLogo
}

type IBrandLogoProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'onError'>

export default function BrandLogo(props: IBrandLogoProps) {
  const { t } = useTranslation()
  const { isLoaded, logo } = useAgencyLogo()
  const [hasLogoFailed, setLogoFailed] = useState(false)

  return isLoaded ? (
    <img
      {...props}
      src={logo && !hasLogoFailed ? logo : blueSystemsLogo}
      alt={t('brandLogo.alt')}
      onError={() => setLogoFailed(true)}
    />
  ) : null
}
